module.exports = __webpack_public_path__ + "static/stork-sbox-3af7c217d176bf3d6e53f6b60c84ec3b.jpg";